var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdf_4726010",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.131,
    height: 28.255,
    viewBox: "0 0 21.131 28.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_15_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63337",
    "data-name": "Path 63337",
    d: "M103.451,0H112.9L120.9,8.345V24.577a3.675,3.675,0,0,1-3.671,3.678H103.451a3.676,3.676,0,0,1-3.678-3.678V3.678A3.676,3.676,0,0,1,103.451,0Z",
    transform: "translate(-99.773 0)",
    fill: "#e5252a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_184780",
    "data-name": "Group 184780",
    transform: "translate(4.088 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63338",
    "data-name": "Path 63338",
    d: "M467.219,0V8.282h8.013Z",
    transform: "translate(-458.189)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63339",
    "data-name": "Path 63339",
    d: "M214.278,451.12v-5.161h2.2a1.82,1.82,0,0,1,1.3.452,1.722,1.722,0,0,1,0,2.4,1.82,1.82,0,0,1-1.3.452H215.6v1.857Zm1.32-2.979h.727a.651.651,0,0,0,.459-.141.545.545,0,0,0,0-.777.651.651,0,0,0-.459-.141H215.6Zm3.205,2.979v-5.161h1.829a3.192,3.192,0,0,1,1.017.155,2.732,2.732,0,0,1,.861.459,2.027,2.027,0,0,1,.607.8,3.191,3.191,0,0,1,0,2.323,2.027,2.027,0,0,1-.607.8,2.735,2.735,0,0,1-.861.459,3.194,3.194,0,0,1-1.017.155ZM220.1,450h.381a2.115,2.115,0,0,0,.572-.071,1.715,1.715,0,0,0,.487-.233,1.047,1.047,0,0,0,.353-.452,2,2,0,0,0,0-1.4,1.047,1.047,0,0,0-.353-.452,1.716,1.716,0,0,0-.487-.233,2.118,2.118,0,0,0-.572-.071H220.1Zm3.9,1.123v-5.161h3.671v1.123H225.32v.826H227.2v1.116H225.32v2.1Z",
    transform: "translate(-214.278 -430.038)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.d69a27cac2dd52bfb6566987c6384d7c.svg";
export { ForwardRef as ReactComponent };